export enum LocalStorage {
  RedirectPath = "redirect",
  Country = "country",
  Market = "market",
  Session = "session",
  OrderId = "order_token",
  User = "user",
  PrefferedLang = "preffered-language",
}
